import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// Define brand colors
const ACCENT_TEAL = "#e1f5f3";
const ACCENT_YELLOW = "#faf2d2";

const BackgroundEffect = styled(Box)(({ theme }) => ({
  label: "label-background-effect",
  '&::before': {
    content: '""',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `linear-gradient(135deg, ${ACCENT_YELLOW} 0%, #eeeeee 50%, ${ACCENT_TEAL} 100%)`,
    zIndex: -2,
  },
  '&::after': {
    content: '""',
    position: 'fixed',
    bottom: -30,
    right: -30,
    width: 250,
    height: 250,
    borderRadius: '50%',
    background: ACCENT_TEAL,
    opacity: 0.08,
    filter: 'blur(60px)',
    zIndex: -1,
  },
  '& > div::after': {
    content: '""',
    position: 'fixed',
    top: -20,
    left: -20,
    width: 180,
    height: 180,
    borderRadius: '50%',
    background: ACCENT_YELLOW,
    opacity: 0.08,
    filter: 'blur(50px)',
    zIndex: -1,
    // display: 'block',
  },
}));

// Simple component that just renders the background effect
const Background = () => (
  <BackgroundEffect>
    <div />
  </BackgroundEffect>
);

export default Background; 